import DragIndicatorIcon from "@mui/icons-material/DragIndicatorRounded";
import { Box, ListItemIcon, type SxProps, type Theme } from "@mui/material";
import useMergedSx from "@entrilia/shared/hooks/useMergedSx";
import type { MetaIcons } from "../../../../../../api/types/svTypes";
import MetaIcon from "./MetaIcon";

interface Props {
  icon: MetaIcons;
  sx?: SxProps<Theme>;
}

const MetaDragListItemIcon = ({ icon, sx }: Props) => {
  const mergedSx = useMergedSx(sx, {
    justifyContent: "center",
    minWidth: "20px",
    "& .meta-icon": { display: "inline-flex" },
    "& .drag-icon": { display: "none" },
  });

  return (
    <ListItemIcon sx={mergedSx}>
      <Box component="span" className="meta-icon">
        <MetaIcon icon={icon} />
      </Box>
      <Box component="span" className="drag-icon">
        <DragIndicatorIcon color="action" />
      </Box>
    </ListItemIcon>
  );
};

export default MetaDragListItemIcon;
